/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { makeStyles } from '@material-ui/core/styles';
// import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Styles from './index.module.css';

const useMenuStyles = makeStyles(() => ({
  paper: {
    backgroundColor: '#EAF0FF',
    paddingTop: 0,
    paddingBottom: 0,
  },
  list: {
    paddingTop: 0,
    paddingBottom: 0,
  },
}));

const useSelectStyles = makeStyles(() => ({
  select: {
    color: '#475E95',
    paddingLeft: 10,
    textAlign: 'left',
    '&:focus': {
      background: '#E4EAF9',
    },
  },
}));

export default function FormSelect({
  value,
  options,
  onChange,
  ...props
}) {
  const menuClasses = useMenuStyles();
  const selectClasses = useSelectStyles();
  return (
    <Select
      disableUnderline
      classes={selectClasses}
      className={Styles.mainContainer}
      onChange={onChange}
      value={value}
      IconComponent={({ style, ...ps }) => (
        <ExpandMoreIcon
          style={{
            fontSize: 36,
            pointerEvents: 'none',
            top: 'unset',
            marginRight: 5,
          }}
          {...ps}
        />
      )}
      MenuProps={{ classes: menuClasses }}
      {...props}
    >
      {
        options.map((option) => (
          <MenuItem
            key={option}
            value={option}
            style={{ color: '#475E95' }}
            // className={Styles.menuItem}
          >
            {option}
          </MenuItem>
        ))
      }
    </Select>
  );
}

FormSelect.propTypes = {
  value: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func,
};

FormSelect.defaultProps = {
  value: '',
  options: [],
  onChange: () => {},
};
